<template>
  <v-dialog v-model="rescheduleAppointment" width="500" persistent>
    <v-card class="pb-4">
      <v-card-title class="primary">
        <span class="white--text">Reschedule Appointment</span>
      </v-card-title>
      <v-card-text class="subtitle-1 pb-0 pt-3">
        <b class="mb-2">Current Appointment Date:</b>
        {{ appointmentData.startDate | formatDateTime(true) }}<br />
        <b>Available Slots:</b>

        <v-radio-group v-model="dateGroup" class="mt-0 pl-3 slot-list">
          <v-radio
            v-for="slot in availableSlots"
            :key="slot.startDatetime"
            :label="slot.startDatetime | formatDateTime(true)"
            :value="slot"
          ></v-radio>
        </v-radio-group>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="mt-4">
        <v-spacer></v-spacer>
        <v-btn
          class="primary mr-2"
          @click="$emit(`processReschedule`, dateGroup)"
          >Reschedule</v-btn
        >
        <v-btn class="mr-4" @click="$emit(`closeReschedule`)">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RescheduleAppointment",
  props: {
    rescheduleAppointment: {
      type: Boolean,
      required: true,
    },
    appointmentData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    dateGroup: null,
  }),
};
</script>

<style lang="css" scoped>
.slot-list {
  max-height: 300px;
  overflow-y: auto;
}
</style>